(function() {
  'use strict';

  angular.module('app').controller('FooterController', FooterController).directive('footer', Toolbar);

// Controller
  FooterController.$inject = ['$scope', '$rootScope', 'SettingsService'];

  function FooterController($scope, $rootScope, SettingsService) {
    $scope.getLocalizedPath = getLocalizedPath;

    $scope.getLegalLinks = function() {
      SettingsService.GetLegalLinks(function(success, response) {
        if (success) {
          $scope.terms_of_service_url = response.terms_of_service_url;
          $scope.terms_of_service_business_url = response.terms_of_service_business_url;
          $scope.privacy_policy_url = response.terms_of_service_url;
        }
      });
    };
    $scope.getLegalLinks();
  }

// Directive
  Toolbar.$inject = [];

  function Toolbar() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/footer.html',
      link: function(scope, element, attrs) {
      }
    };
  }
})();
